var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.88 30.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#868787;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,7.61h5.48v2.3H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,12.84h5.48v2.3H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,18.07h5.48v2.3H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,23.31h5.48v2.3H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.12,28.67V9.87l12,0V22.54h2.3V8.7a1.16,1.16,0,0,0-1.15-1.15L18,7.57a1.15,1.15,0,0,0-1.15,1.15v20H4.74V5.9L16.82,2.65V5.26h2.3V1.15A1.16,1.16,0,0,0,17.68,0L3.29,3.91A1.15,1.15,0,0,0,2.44,5V28.67H0V31H35.88v-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.14,24.61h2.3v2.14h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.36,12.84h5.48v2.3H22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.36,18.07h5.48v2.3H22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.36,23.31h5.48v2.3H22.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.d4544a574564e132478fbb34f5ae71f4.svg";
export { ForwardRef as ReactComponent };